import React, { useState } from 'react';
import image1 from './Squad/Team/Without BG/Muhammed Jasim [Blocker].png';
import image2 from './Squad/Team/Without BG/Mannat Choudhary [Attacker].png';
import image3 from './Squad/Team/Without BG/George Anthony [Attacker].png';
import image4 from './Squad/Team/Without BG/Abhishek Rajeev [Opposite].png';
import image5 from './Squad/Team/Without BG/Saqlain Tariq [Setter].png';
import image6 from './Squad/Team/Without BG/Rijas K R [Blocker].png';
import image7 from './Squad/Team/Without BG/Anand K [Blocker].png';
import image8 from './Squad/Team/Without BG/Anu James [Attacker].png';
import image9 from './Squad/Team/Without BG/Ayush Kasnia [Blocker].png';
import image10 from './Squad/Team/Without BG/Avinash Choudhary [Setter].png';
import image11 from './Squad/Team/Without BG/Ajay Kumar [Blocker].png';
import image12 from './Squad/Team/Without BG/Aljo Sabu [Libero].png';
import image13 from './Squad/Team/Without BG/Carlos Berrios [Attacker].png';
import image14 from './Squad/Team/Without BG/Jesus Chourio [Opposite].png';

import selectedImage1 from './Squad/Team/With BG/Muhammed Jasim [Blocker].png';//Muhammed Jasim
import selectedImage2 from './Squad/Team/With BG/Mannat Choudhary [Attacker].png';
import selectedImage3 from './Squad/Team/With BG/George Anthony [Attacker].png';
import selectedImage4 from './Squad/Team/With BG/Abhishek Rajeev [Opposite].png';//Abhishek Rajeev
import selectedImage5 from './Squad/Team/With BG/Saqlain Tariq [Setter].png';
import selectedImage6 from './Squad/Team/With BG/Rijas K R [Blocker].png';//Rijas K R
import selectedImage7 from './Squad/Team/With BG/Anand K [Blocker].png';
import selectedImage8 from './Squad/Team/With BG/Anu James [Attacker].png';
import selectedImage9 from './Squad/Team/With BG/Ayush Kasnia [Blocker].png';
import selectedImage10 from './Squad/Team/With BG/Avinash Choudhary [Setter].png';//Avinash Choudhary
import selectedImage11 from './Squad/Team/With BG/Ajay Kumar [Blocker].png';//Ajay Kumar
import selectedImage12 from './Squad/Team/With BG/Aljo Sabu [Libero].png';//Aljo Sabu
import selectedImage13 from './Squad/Team/With BG/Carlos Berrios [Attacker].png';//Carlos Berrios
import selectedImage14 from './Squad/Team/With BG/Jesus Chourio [Opposite].png';//Jesus Chourio
import { Link } from 'react-router-dom';

const Squad = () => {
  const players = [
    {
      name: 'Muhammed Jasim',
      role: 'Middle Blocker',
      thumbnail: image1,
      image: selectedImage1,
      details: {
        name: 'Muhammed Jasim',
        position: 'Middle Blocker',
        description: "A promising young Blocker from Kerala, Muhammed Jasim is a rising star in the Prime Volleyball League. His skills were in high demand during the league's auction, reflecting his potential.",
        stats: {
          Height: 207,
          Hname:'Height (cms).',
          SpikeH: 365,
          SHname:'Spike Height (cms).',
          BlockH: 355,
          BHname:'Block Height (cms).'
        },
      },
    },
    {
      name: 'Mannat Choudhary',
      role: 'Attacker',
      thumbnail: image4,
      image: selectedImage4,
      details: {
        name: 'Mannat Choudhary',
        position: 'Attacker',
        description: "Mannat Choudhary is a dynamic attacker from Jammu & Kashmir, known for his powerful hits and fearless presence at the net. With sharp instincts and explosive movement, he brings relentless energy to every rally. Mannat has been a prolific performer at the Poonch Volleyball League and has represented the national U-20 team at the Asian Volleyball Championship.",
        stats: {
          Height: 191,
          Hname:'Height (cms).',
          SpikeH: 355,
          SHname:'Spike Height (cms).',
          BlockH: 330,
          BHname:'Block Height (cms).'
        },
      },
    },
    {
      name: 'George Anthony',
      role: 'Attacker',
      thumbnail: image2,
      image: selectedImage2,
      details: {
        name: 'George Anthony',
        position: 'Attacker',
        description: "George Anthony is a rising star in Indian volleyball, known for his powerful spikes and solid all-round gameplay. As an Attacker he combines agility with strength, making him a constant threat at the net. His consistency and work ethic have quickly made him one of the most exciting talents to watch on the court.",
        stats: {
          Height: 190,
          Hname:'Height (cms).',
          SpikeH: 348,
          SHname:'Spike Height (cms).',
          BlockH: 339,
          BHname:'Block Height (cms).'
        },
      },
    },
    {
      name: 'Abhishek Rajeev ',
      role: 'Opposite ',
      thumbnail: image3,
      image: selectedImage3,
      details: {
        name: 'Abhishek Rajeev',
        position: 'Opposite',
        description: "Abhishek Rajeev is an emerging Indian volleyball talent, recognized for his athleticism and enthusiasm on the court. With impressive performances in the amateur circuit, Rajeev has been steadily making a name for himself in regional volleyball circles. ",
        stats: {
          Height: 192,
          Hname:'Height (cms).',
          SpikeH: 320,
          SHname:'Spike Height (cms).',
          BlockH: 345,
          BHname:'Block Height (cms).'
        },
      },
    },
    {
      name: 'Saqlain Tariq',
      role: 'Setter',
      thumbnail: image5,
      image: selectedImage5,
      details: {
        name: 'Saqlain Tariq',
        position: 'Setter',
        description: "The captain and setter for the Delhi Toofans, Saqlain Tariq, is a trailblazer from Jammu & Kashmir. He is the first player from his state to represent the Indian national team, which he has also captained. His exceptional skills were recognized with the 'Best Setter' award at the 38th World Military Games.",
        stats: {
          Height: 190,
          Hname:'Height (cms).',
          SpikeH: 328,
          SHname:'Spike Height (cms).',
          BlockH: 310,
          BHname:'Block Height (cms).'
        },
      },
    },
    {
      name: 'Rijas K R',
      role: 'Middle blocker ',
      thumbnail: image6,
      image: selectedImage6,
      details: {
        name: 'Rijas K R',
        position: 'Middle blocker ',
        description: " Rijas K R is a talented volleyball player, known for his powerful spikes and strong presence on the court. He earned selection to the Indian University Volleyball team, showcasing his ability to perform at higher levels. Active in regional clubs and university competitions, Rijas demonstrates solid all-round skills and leadership, making him a standout athlete.",
        stats: {
          Height: 200,
          Hname:'Height (cms).',
          SpikeH: 345,
          SHname:'Spike Height (cms).',
          BlockH: 340,
          BHname:'Block Height (cms).'
        },
      },
    },
    {
      name: 'Anand K',
      role: 'Libero',
      thumbnail: image7,
      image: selectedImage7,
      details: {
        name: 'Anand K',
        position: 'Libero',
        description: "A dynamic and agile Libero from Kerala, Anand K is a key defensive player for the Delhi Toofans. He is known for his exceptional defensive skills and successful digs. ",
        stats: {
          Height: 174,
          Hname:'Height (cms).',
          SpikeH: 320,
          SHname:'Spike Height (cms).',
          BlockH: 310,
          BHname:'Block Height (cms).'
        },
      },
    },
    {
      name: 'Anu James',
      role: 'Attacker',
      thumbnail: image8,
      image: selectedImage8,
      details: {
        name: 'Anu James',
        position: 'Attacker',
        description: " An experienced attacker from Kerala, Anu James has a strong background in Indian volleyball. He was part of the junior Indian team.",
        stats: {
          Height: 192,
          Hname:'Height (cms).',
          SpikeH: 345,
          SHname:'Spike Height (cms).',
          BlockH: 330,
          BHname:'Block Height (cms).'
        },
      },
    },
    {
      name: 'Aayush Kasnia',
      role: 'Middle Blocker',
      thumbnail: image9,
      image: selectedImage9,
      details: {
        name: 'Aayush Kasnia',
        position: 'Middle Blocker',
        description: "Aayush Kasnia, a Blocker from Haryana, is a vital part of the Delhi Toofans' defense. His well-timed blocks have been a significant advantage for the team in the Prime Volleyball League.",
        stats: {
          Height: 204,
          Hname:'Height (cms).',
          SpikeH: 345,
          SHname:'Spike Height (cms).',
          BlockH: 340,
          BHname:'Block Height (cms).'
        },
      },
    },
    {
      name: 'Avinash Choudhary',
      role: 'Setter',
      thumbnail: image10,
      image: selectedImage10,
      details: {
        name: 'Avinash Choudhary',
        position: 'Setter',
        description: " Avinash Choudhury is an emerging volleyball player from Haryana, admired for his athletic ability and court awareness. Whether as a hitter or defender, he brings energy and dedication to team practices and match play. Active in local and university circuits, Avinash's steady growth and enthusiasm mark him as a promising talent in regional volleyball.",
        stats: {
          Height: 186,
          Hname:'Height (cms).',
          SpikeH: 328,
          SHname:'Spike Height (cms).',
          BlockH: 312,
          BHname:'Block Height (cms).'
        },
      },
    },
    {
      name: 'Ajay Kumar',
      role: 'Middle blocker',
      thumbnail: image11,
      image: selectedImage11,
      details: {
        name: 'Ajay Kumar',
        position: 'Middle blocker',
        description: "Ajay Kumar is an emerging blocker from Haryana, bringing grit, strength, and sharp instincts to the front row. Known for his timing and fearless presence at the net, Ajay is adept at shutting down attacks and turning defense into opportunity.",
        stats: {
          Height: 198,
          Hname:'Height (cms).',
          SpikeH: 350,
          SHname:'Spike Height (cms).',
          BlockH: 335,
          BHname:'Block Height (cms).'
        },
      },
    },
    {
      name: 'Aljo Sabu',
      role: 'Libero',
      thumbnail: image12,
      image: selectedImage12,
      details: {
        name: 'Aljo Sabu',
        position: 'Libero',
        description: "Aljo Sabu is a skilled libero from Kerala, known for his lightning-quick reactions and exceptional court coverage. With a calm head and sharp game sense, Aljo anchors the backline with consistency and composure. His ability to read the game and deliver under pressure makes him a reliable force in defense and a vital asset to the team.",
        stats: {
          Height: 175,
          Hname:'Height (cms).',
          SpikeH: 310,
          SHname:'Spike Height (cms).',
          BlockH: 200,
          BHname:'Block Height (cms).'
        },
      },
    },
    {
      name: 'Carlos Berrios',
      role: 'Attacker',
      thumbnail: image13,
      image: selectedImage13,
      details: {
        name: 'Carlos Berrios',
        position: 'Attacker',
        description: "Carlos Berrios is the newest addition to the Delhi Toofans franchise. Hailing from Venezuela, the 20 year old brings the much needed South American flair to our attacking line-up.",
        stats: {
          Height: 192,
          Hname:'Height (cms).',
          SpikeH: 345,
          SHname:'Spike Height (cms).',
          BlockH: 320,
          BHname:'Block Height (cms).'
        },
      },
    },
    {
      name: 'Jesus Chourio',
      role: 'Opposite',
      thumbnail: image14,
      image: selectedImage14,
      details: {
        name: 'Jesus Chourio',
        position: 'Opposite',
        description: " Versatile and impactful, Jesus Chourio plays the Universal role with power and precision. Whether it's attacking at the net or stepping in for a crucial dig, he brings balance and adaptability to every rotation. With strong fundamentals and a high volleyball IQ, Jesus is a dependable all-rounder capable of turning the tide at any moment.",
        stats: {
          Height: 201,
          Hname:'Height (cms).',
          SpikeH: 365,
          SHname:'Spike Height (cms).',
          BlockH: 355,
          BHname:'Block Height (cms).'
        },
      },
    },
    // Add more players as needed
  ];

  const [selectedPlayer, setSelectedPlayer] = useState(players[0]);

  const handlePlayerClick = (player) => {
    setSelectedPlayer(player);
  };

  return (
    <section className='bg-[#3b0067] md:pt-6 justify-center items-center mx-auto m-2 md:my-10 md:px-[9rem]'>
      <h1 className='md:text-5xl text-3xl text-white text-center font-bold mb-7'>Squad</h1>
      <div className='flex flex-col lg:flex-row gap-5 h-auto'>
      <div className='flex flex-col w-full justify-center lg:w-1/3'>
          <div className='h-96 overflow-y-auto'>
            {players.map((player, index) => (
              <div 
                key={index} 
                className='flex items-center p-2 rounded-md cursor-pointer'
                onClick={() => handlePlayerClick(player)}
              >
                <img src={player.thumbnail} alt={player.name} className='w-20 h-20 object-fill shadow-2xl rounded-md' />
                <div className='ml-4 text-white'>
                  <h4 className='text-lg font-bold'>{player.name}</h4>
                  <span className='text-sm'>{player.role}</span>
                </div>
              </div>
            ))}
          </div>
          <Link to={'/Squad'}>
          <button className='bg-[#ffbd00] px-5 py-1.5 w-24 text-sm rounded-md text-black font-medium mt-3'>View All</button>
          </Link>
        </div>

        <div className='w-full lg:w-1/3 h-auto'>
          <img src={selectedPlayer.image} alt="News" className='rounded-md' />
        </div>

        <div className='w-full lg:w-1/3 pl-4 pt-10'>
          <h2 className='text-3xl font-bold mb-3 text-[#ffbd00]'>{selectedPlayer.details.name}</h2>
          <h5 className='text-xl text-white mb-4 font-semibold'>{selectedPlayer.details.position}</h5>
          <p className='text-sm text-white mb-4'>{selectedPlayer.details.description}</p>
          <div className='grid grid-cols-4 gap-2 text-white'>
            <div className='text-left '>
              <span className='text-2xl font-extrabold block'>{selectedPlayer.details.stats.TotalP || selectedPlayer.details.stats.Height}</span>
              <span className='text-sm font-bold'>{selectedPlayer.details.stats.TPName || selectedPlayer.details.stats.Hname }</span>
            </div>
            <div className='text-left'>
              <span className='text-2xl font-extrabold block'>{selectedPlayer.details.stats.AttackP || selectedPlayer.details.stats.SpikeH}</span>
              <span className='text-sm font-bold '>{selectedPlayer.details.stats.APName || selectedPlayer.details.stats.SHname }</span>
            </div>
            <div className='text-left'>
              <span className='text-2xl font-extrabold block'>{selectedPlayer.details.stats.BlockP || selectedPlayer.details.stats.BlockH}</span>
              <span className='text-sm font-bold  '>{selectedPlayer.details.stats.BPName || selectedPlayer.details.stats.BHname }</span>
            </div>
            <div className='text-left'>
              <span className='text-2xl font-extrabold block'>{selectedPlayer.details.stats.ServeP}</span>
              <span className='text-sm font-bold '>{selectedPlayer.details.stats.SPName}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Squad;
